import script from "./ChipCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./ChipCounter.vue?vue&type=script&setup=true&lang=js"

import "./ChipCounter.vue?vue&type=style&index=0&id=2d8d6499&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8d6499"]])

export default __exports__